// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"745":"85d73d44","939":"0d7c1fd5","982":"cd106350"}[chunkId] + ".css";
};